(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('Event', Event);

    Event.$inject = ['$resource', 'DateUtils'];

    function Event ($resource, DateUtils) {
        var resourceUrl =  'api/events/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.startedAt = DateUtils.convertDateTimeFromServer(data.startedAt);
                        data.finishedAt = DateUtils.convertDateTimeFromServer(data.finishedAt);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
